// import axios from "axios";
import { api } from "../../apiendpoints/index";
import axios from "../../axiosMiddleware";

// Pre-Recruitment Process
export const AddRecruitee = async (formData) => {
  return axios.post(`${api.HUMAN_RESOURCE.ADD_RECRUITEE}`, formData);
};
export const GetRecruiteeDropdowns = async () => {
  return axios.get(`${api.HUMAN_RESOURCE.GET_RECRUITEE_DROPDOWN_DATA}`);
};
export const GetAllRecruitees = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.ALL_RECRUITEES}`, data);
};
export const EvalutionProcessGenral = async (formData) => {
  return axios.post(`${api.HUMAN_RESOURCE.EvalutionProcessGenral}`, formData);
};
export const EvalutionProcessTech1 = async (formData) => {
  return axios.post(`${api.HUMAN_RESOURCE.EvalutionProcessTech1}`, formData);
};
export const EvalutionProcessTech2 = async (formData) => {
  return axios.post(`${api.HUMAN_RESOURCE.EvalutionProcessTech2}`, formData);
};
export const EvalutionProcessHR = async (formData) => {
  return axios.post(`${api.HUMAN_RESOURCE.EvalutionProcessHR}`, formData);
};
export const DownloadRecruiteePdf = async (id) => {
  return axios.get(`${api.HUMAN_RESOURCE.DOWNLOAD_PDF_HR}?Id=${id}`);
};
export const DownloadRecruiteeEvalutionPdf = async (id) => {
  return axios.get(`${api.HUMAN_RESOURCE.DownloadRecruiteeEvalutionPdf}?Id=${id}`);
};
export const GetAllRecruiteeID = async (id) => {
  return axios.get(`${api.HUMAN_RESOURCE.EvalutionForm}?Id=${id}`);
};
export const GetEvalutionById = async (id) => {
  return axios.get(`${api.HUMAN_RESOURCE.GetEvalutionById}?Id=${id}`);
};
export const AddEvalutionForm = async (formData) => {
  return axios.post(`${api.HUMAN_RESOURCE.AddEvalutionForm}`, formData);
};

// Welcome New Employee
export const AddNewEmployee = async (formData) => {
  return axios.post(`${api.HUMAN_RESOURCE.WELCOME_NEW_EMPLOYEE}`, formData);
};

// Employee Of The Month
export const GetExtraOrdinaryAboutNominee = async () => {
  return axios.get(`${api.HUMAN_RESOURCE.GET_EXTRAORDINARY_ABOUT_NOMINEE}`);
};
export const AddEmpOfTheMonth = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.ADD_EMP_OF_THE_MONTH}`, data);
};
export const GetAllEmployeeDetailsDropdowns = async () => {
  return axios.get(`${api.ADMIN.ALL_EMP_DETAILS_DROPDOWNS}`);
};
export const GetAllEmployeeOfTheMonthNominees = async (data) => {
  return axios.post(
    `${api.HUMAN_RESOURCE.GET_ALL_EMP_OF_The_MONTH_NOMINEES}`,
    data
  );
};
export const GetNomineebyId = async (id) => {
  return axios.get(`${api.HUMAN_RESOURCE.GET_NOMINEE_BYID}?NomineeId=${id}`);
};

// Let's Know Each Other Details
export const AddLetsKnowEachOther = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.ADD_LETS_KNOW_EACH_OTHER}`, data);
};
export const GetAllLetsKnowEachOther = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GATE_ALL_LKEO_DETAILS}`, data);
};
export const GetLetsKnowEachOtherById = async (id) => {
  return axios.get(`${api.HUMAN_RESOURCE.GET_LKEO_BY_ID}?Id=${id}`);
};

// Gate Pass
export const AddGatepass = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.ADD_GATE_PASS}`, data);
};
export const GetAllGatepasses = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GET_ALL_GP_DETAILS}`, data);
};
export const GetGatepassById = async (id) => {
  return axios.get(`${api.HUMAN_RESOURCE.GET_GP_DETAILS_BYID}?Id=${id}`);
};

// Leave Sheet
export const GetLeaveById = async (id) => {
  return axios.get(
    `${api.HUMAN_RESOURCE.GET_EMP_LEAVE_DETAILS_BYID}?UserId=${id}`
  );
};
export const AddLeave = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.ADD_NEW_LEAVE}`, data);
};
export const GetAllLeaveSheets = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GET_ALL_LEAVESHEET}`, data);
};
export const GetLeaveSheetById = async (id) => {
  return axios.get(
    `${api.HUMAN_RESOURCE.GET_LEAVESHEET_DETAILS_BYID}?Id=${id}`
  );
};

// Training course
export const AddDepartmentCourse = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.ADD_NEW_DEPRT_COURSE}`, data);
};
export const GetAllDepartmentCourse = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GET_ALL_DEPRT_COURSE}`, data);
};
export const GetDepartmentCourseById = async (id) => {
  return axios.get(`${api.HUMAN_RESOURCE.GET_DEPRT_COURSE_BYID}?Id=${id}`);
};

// Training

export const GetDepartmentCoursesByDepartmentId = async (user) => {
  return axios.get(
    `${api.HUMAN_RESOURCE.GET_DEPT_COURSE_BY_DEPTID}?DepartmentId=${user}`
  );
};
export const AddOrEditTraining = async (formData) => {
  return axios.post(`${api.HUMAN_RESOURCE.ADD_OR_EDIT_TRAINING}`, formData);
};
export const GetAllTrainingList = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GET_ALL_TRAINING_LIST}`, data);
};
export const GetTrainingById = async (user) => {
  return axios.get(
    `${api.HUMAN_RESOURCE.GET_TRAINING_BY_ID}?TrainingId=${user}`
  );
};
export const DeleteTraining = (id, isDeleted) => {
  return axios.post(
    `${api.HUMAN_RESOURCE.DELETE_TRAINING}?TrainingId=${id}&IsDeleted=${isDeleted}`
  );
};
export const GetAllInstructorByTrainingDropDownList = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GET_ALL_INSTRUCTOR_BY_TRAINING_DROPDOWN}`, data);
};
export const GetAllEmployeeTrainingDropDownList = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GET_ALL_EMPLOYEE_BY_TRAINING_DROPDOWN}`, data);
};
export const GetAllCourseByTrainingDropDownList = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GET_ALL_COURSE_BY_TRAINING_DROPDOWN}`, data);
};
export const GetAllHoursByTrainingDropDownList = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GET_ALL_HOURS_BY_TRAINING_DROPDOWN}`, data);
};
export const GetTrainingDetailsByEmployeeId = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GET_TRAINING_DETAILS_BY_EMPLOYEE_ID}`, data);
};
export const GetTrainingDetailsByCourseId = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GET_TRAINING_DETAILS_BY_COURSE_ID}`, data);
};
export const GetTrainingDetailsByInstructorName = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GET_TRAINING_DETAILS_BY_INSTRUCTOR_NAME}`, data);
};

// Email For Training
export const SendTrainingNotification = async (formData) => {
  return axios.post(`${api.HUMAN_RESOURCE.SEND_TRAINING_NOTIFICATION}`, formData
  );
}
  export const AddorEditQuestion = async (formData) => {
    return axios.post(`${api.HUMAN_RESOURCE.ADD_OR_EDIT_QUESTION}`, formData
    );
  }
  export const GetAllQuestionCategories = async () => {
    return axios.get(`${api.HUMAN_RESOURCE.GET_ALL_QUESTIONS_CATEGORIES}`);
  }
  export const GetAllQuestions = async (data) => {
    return axios.post(`${api.HUMAN_RESOURCE.GET_ALL_QUESTIONS}`, data);
  }
  export const GetQuestionById = async (id) => {
    return axios.get(`${api.HUMAN_RESOURCE.GET_QUESTION_BY_ID}?Id=${id}`);
  }
  export const ChangeQuestionStatus = async (data) => {
    return axios.post(`${api.HUMAN_RESOURCE.CHANGE_QUESTION_STATUS}`,data);
  }
  export const AddCandidateCV = async (data) => {
    return axios.post(`${api.HUMAN_RESOURCE.ADD_CANDIDATE_CV}`,data);
  }

export const GetCandidateCV = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GET_ALL_CANDIDATE_CV}`,data);
}
